module.exports = __webpack_public_path__ + "static/media/img2.25a008d8.jpg";